const PREFIX = 'FORM_RESPONSE_'
export const FORM_RESPONSE = {
  LIST_REQUEST: `${PREFIX}LIST_REQUEST`,
  LIST_SUCCESS: `${PREFIX}LIST_SUCCESS`,
  LIST_FAILURE: `${PREFIX}LIST_FAILURE`,
  GET_ONE_REQUEST: `${PREFIX}GET_ONE_REQUEST`,
  GET_ONE_SUCCESS: `${PREFIX}GET_ONE_SUCCESS`,
  GET_ONE_FAILURE: `${PREFIX}GET_ONE_FAILURE`,
  CREATE_REQUEST: `${PREFIX}CREATE_REQUEST`,
  CREATE_SUCCESS: `${PREFIX}CREATE_SUCCESS`,
  CREATE_FAILURE: `${PREFIX}CREATE_FAILURE`,
  UPDATE_REQUEST: `${PREFIX}UPDATE_REQUEST`,
  UPDATE_SUCCESS: `${PREFIX}UPDATE_SUCCESS`,
  UPDATE_FAILURE: `${PREFIX}UPDATE_FAILURE`,
  DELETE_REQUEST: `${PREFIX}DELETE_REQUEST`,
  DELETE_SUCCESS: `${PREFIX}DELETE_SUCCESS`,
  DELETE_FAILURE: `${PREFIX}DELETE_FAILURE`,
  CLEAR: `${PREFIX}CLEAR`
}
